// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import __setDefaultSdkOptions from "../sdk-helpers/__setDefaultSdkOptions";

import createLeagueCatalogGet from "./leagueCatalog/postLeagueCatalogGet";
import createLeagueConferenceList from "./league/postLeagueConferenceList";
import createLeagueList from "./league/postLeagueList";
import createPlayerSeasonStatsGet from "./player/postPlayerSeasonStatsGet";
import createSearchTeamsPlayers from "./search/postSearchTeamsPlayers";
import createSportList from "./sport/postSportList";
import createStandingsGet from "./standings/postStandingsGet";
import createTeamGet from "./team/postTeamGet";
import createTeamGetMany from "./team/postTeamGetMany";
import createTeamInjuriesGet from "./team/postTeamInjuriesGet";
import createTeamList from "./team/postTeamList";
import createTeamPlayerStatsGet from "./team/postTeamPlayerStatsGet";
import createTeamProfileGet from "./team/postTeamProfileGet";
import createTeamRosterGet from "./team/postTeamRosterGet";
import createTeamSeasonStatsGet from "./team/postTeamSeasonStatsGet";

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

// Every method is built from RESOLVED options, never the raw argument.
// `sdk()` with no arguments has to work. That is the shape every generated
// hook uses through useCallSdk(), and passing the raw `undefined` through
// gave those methods no apiHost and no "/v1/<zone>" prefix, so they POSTed to
// a bare relative "/resource/action".
export default function sdk(options?: SdkOptions) {
  const resolvedOptions = __setDefaultSdkOptions(options);
  return {
    postLeagueCatalogGet: createLeagueCatalogGet(resolvedOptions),
    postLeagueConferenceList: createLeagueConferenceList(resolvedOptions),
    postLeagueList: createLeagueList(resolvedOptions),
    postPlayerSeasonStatsGet: createPlayerSeasonStatsGet(resolvedOptions),
    postSearchTeamsPlayers: createSearchTeamsPlayers(resolvedOptions),
    postSportList: createSportList(resolvedOptions),
    postStandingsGet: createStandingsGet(resolvedOptions),
    postTeamGet: createTeamGet(resolvedOptions),
    postTeamGetMany: createTeamGetMany(resolvedOptions),
    postTeamInjuriesGet: createTeamInjuriesGet(resolvedOptions),
    postTeamList: createTeamList(resolvedOptions),
    postTeamPlayerStatsGet: createTeamPlayerStatsGet(resolvedOptions),
    postTeamProfileGet: createTeamProfileGet(resolvedOptions),
    postTeamRosterGet: createTeamRosterGet(resolvedOptions),
    postTeamSeasonStatsGet: createTeamSeasonStatsGet(resolvedOptions),
  };
}
